import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { AcceptedCookiePolicyType, CookieTypeEnum } from "~/types-and-enums/cookieTypes";
import { PurchaseOrderType } from "~/types-and-enums/purchaseOrderTypes";

export const cookieModalAtom = atom<boolean>(false);

export const openDarkBackgroundAtom = atom<boolean>(false);

export const acceptedCookiePolicyAtom = atomWithStorage<AcceptedCookiePolicyType>(
  "acceptedCookiePolicy",
  CookieTypeEnum.ErrorTracking
);

export const purchaseOrdersAtom = atom<PurchaseOrderType[]>([]);

export const forgotPasswordEmailAtom = atom<string>("");

export type RegistrationFormData = {
  // Step 1
  first_name: string;
  last_name: string;
  email_address: string;
  telephone_number: string;
  // Step 2
  company_name: string;
  business_type: "DISTRIBUTOR" | "MANUFACTURER" | "ORIGINAL_EQUIPMENT_MANUFACTURER" | "";
  street: string;
  city: string;
  country: string;
  postal_code: string;
  annual_revenue_in_net_eur: string;
};

export const registrationFormAtom = atom<RegistrationFormData>({
  first_name: "",
  last_name: "",
  email_address: "",
  telephone_number: "",
  company_name: "",
  business_type: "",
  street: "",
  city: "",
  country: "",
  postal_code: "",
  annual_revenue_in_net_eur: "",
});
